export default __webpack_public_path__ + "static/media/Custom Software Development 1.9b719a48.png";